/**
 * Thin wrapper around the legacy Buffer API routes used by the composer.
 */

import callRpc from '~publish/legacy/utils/call-rpc'

type RequestSettings = {
  method?: string
}

const request = <T = unknown>(
  url: string,
  data: Record<string, unknown> = {},
  settings: RequestSettings = {},
): Promise<T> =>
  callRpc('composerApiProxy', {
    url: `/1/${url}`,
    args: data,
    HTTPMethod: settings.method,
  })

const API = {
  request,
  get: <T = unknown>(url: string, data?: Record<string, unknown>): Promise<T> =>
    request<T>(url, data, { method: 'GET' }),
  post: <T = unknown>(
    url: string,
    data?: Record<string, unknown>,
  ): Promise<T> => request<T>(url, data, { method: 'POST' }),
}

export default API
